export const checkDate = (
    date1: Date,
    date2: Date
): boolean => {
    return date1 && date2 &&
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}
